import { render, staticRenderFns } from "./DashboardFilters.vue?vue&type=template&id=4fed41fe&"
import script from "./DashboardFilters.vue?vue&type=script&lang=js&"
export * from "./DashboardFilters.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFilters.vue?vue&type=style&index=0&id=4fed41fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports